import React, { useState } from "react"
import L10n from "lib/carrot-l10n"
import WizardWrapper from "components/views/atoms/forms/WizardWrapper"
import RequestCardHeader from "components/views/requestcard/RequestCardHeader"
import { HR, Spacer } from "../atoms/Atoms"
import Title from "../Title"
import RequestCardWizardHeader from "components/views/requestcard/RequestCardWizardHeader"
import { Body } from "../atoms/Bodies"
import { MasterLayout } from "../atoms/layouts/MasterLayout"
import { BodyWithRightSidebarLayout } from "../atoms/layouts/BodyWithRightSidebarLayout"
import { TwoColumnRow } from "../account/Shared"
import { CompleteUsaStateSelect } from "components/views/atoms/forms/FormUsaStateSelect"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { useDispatch, useSelector } from "react-redux"
import { getHasRequestCardInformationPage } from "derivedSelectors"
import { reportError } from "utils/ErrorReporting"
import { getUserInfo } from "reducers/userInfo"
import { useForm } from "react-hook-form"
import { createCardholder } from "actions"
import { useHistory } from "react-router"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const RequestCardMailingAddress = (props) => {
  const userInfo = useSelector(getUserInfo)
  const [isAddressError, setIsAddressError] = useState(false)
  const hasRequestCardInformationPage = useSelector(getHasRequestCardInformationPage)
  const dispatch = useDispatch()
  const history = useHistory()

  const { handleSubmit, register, errors, formState } = useForm({
    defaultValues: {
      address1: userInfo.address1,
      address2: userInfo.address2,
      city: userInfo.city,
      state: userInfo.state,
      zip: userInfo.zip
    }
  })

  const formComplete = Object.keys(errors).length === 0

  const onSubmit = handleSubmit(async (formValues) => {
    setIsAddressError(false)
    try {
      await dispatch(
        createCardholder(formValues.address1, formValues.address2, formValues.city, formValues.state, formValues.zip)
      )
    } catch (e) {
      setIsAddressError(true)
      e.message =
        `Error for employeeId: "${userInfo.employeeId}" while confirming Carrot Card® address: RAW:` + e.message
      reportError(e)
      return
    }

    setIsAddressError(false)
    history.push(props.requestCardPath + "/phone-number")
  })

  return (
    <MasterLayout
      header={
        <RequestCardHeader
          backRoute={hasRequestCardInformationPage ? props.requestCardPath + "/information" : "/transactions"}
        />
      }
    >
      <Title title={l`carrotCard.getYourCarrotCard`} />
      <BodyWithRightSidebarLayout>
        <RequestCardWizardHeader step={1}>
          <span id="request-card-mailing-address-header">{l`carrotCard.request.confirmYourAddress`}</span>
        </RequestCardWizardHeader>
        <WizardWrapper
          back
          backText={l(hasRequestCardInformationPage ? "back" : "cancel")}
          done
          backRoute={hasRequestCardInformationPage ? props.requestCardPath + "/information" : "/transactions"}
          doneText={l`next`}
          onDone={onSubmit}
          sending={formState.isSubmitting}
        >
          {!formComplete ? (
            <Body color="carrot-red">{l`carrotCard.request.addressIncomplete`}</Body>
          ) : isAddressError ? (
            <Body color="carrot-red">{l`carrotCard.request.addressError`}</Body>
          ) : (
            <Body color="black-60">{l`carrotCard.request.addressDescription`}</Body>
          )}
          <Spacer height={1.5} />
          <CompleteFormInput
            label={l`carrotCard.request.addressLine1`}
            name="address1"
            errors={errors}
            ref={register({
              required: "Please enter address line 1"
            })}
            showValidation={false}
          />
          <Spacer height={1.5} />
          <CompleteFormInput
            name="address2"
            label={l`carrotCard.request.addressLine2`}
            errors={errors}
            ref={register}
            showValidation={false}
          />
          <Spacer height={1.5} />
          <CompleteFormInput
            label={l`carrotCard.request.city`}
            errors={errors}
            ref={register({
              required: "Please enter a city"
            })}
            name="city"
            showValidation={false}
          />
          <Spacer height={1.5} />
          <TwoColumnRow
            left={
              <CompleteUsaStateSelect
                name="state"
                errors={errors}
                ref={register({
                  required: "Please enter a state"
                })}
                label={l`carrotCard.request.state`}
                showValidation={false}
                valid
              />
            }
            right={
              <CompleteFormInput
                label={l`carrotCard.request.zipCode`}
                name="zip"
                errors={errors}
                ref={register({
                  required: "Please enter a zip code"
                })}
                showValidation={false}
              />
            }
          />
          <Spacer height={1} />
        </WizardWrapper>
        <Spacer height={1.5} />
        <HR color="black-20" />
      </BodyWithRightSidebarLayout>
    </MasterLayout>
  )
}

export { RequestCardMailingAddress }
